/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, isFunction } from 'lodash';

// Components
import SmartTable from 'shared/ui/components/tables/SmartTable.vue';
import ListExportModal from 'shared/ui/components/modals/ListExportModal.vue';
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';

const __vue_script__ = {
    name: 'QrCodes',

    components: { SmartTable, ListExportModal, LoaderButton, SearchBar },

    props: {
        params: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            cols: [],
            currentPage: 1,
            eid: this.params.event._id,
            loading: false,
            metadata: {},
            rows: [],
            searchTerm: '',
            sortField: 'title',
            total: null,
            processing: false,
            limit: this.$services.documents.MAX_DOCS_PER_PAGE
        };
    },

    watch: {
        searchTerm() {
            this.loadData();
        }
    },

    async created() {
        this.metadata = await this.$services.metadata.getMetadataForType(this.eid, 'attendance-qr');
        this.cols = this.getColsConfig();
        this.loadData();
    },

    methods: {
        /**
         * Loads the collection to display on the table
         *
         */
        async loadData(page = this.currentPage) {
            try {
                if (this.loading) {
                    return;
                }

                this.loading = true;

                /** @type {UserRow[]} */
                const { items, total } = await this.$services.documents.getAttendanceQrs(
                    this.eid,
                    {
                        page,
                        limit: this.limit,
                        search: this.searchTerm,
                        sort: this.sortField,
                    },
                );
                this.rows = items;
                console.log('rows', this.rows);
                this.total = total;
                console.log('total', this.total);
                this.currentPage = page;
            } catch (error) {
                console.error('[SelfSessionCheckin] Could not load data', error.message);
                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('general.try_later').toString(),
                    type: 'error',
                    duration: 5000
                });
            } finally {
                this.loading = false;
            }
        },

        /**
         * @returns {object[]} each column configuration
         */
        getColsConfig() {
            const cols = [
                {
                    field: 'title',
                    label: 'self_check_in.qr_codes.list.title',
                    link: '/event/{{eventId}}/attendance-qrs/{{_id}}',
                    sortable: 'title'
                },
                {
                    field: 'scansCount',
                    label: 'self_check_in.qr_codes.list.scans',
                    sortable: 'scansCount',
                },
            ];

            return cols;
        },

        newQrCode() {
            const route = get(this.params, 'module.controllers.create.route');
            return route.replace(':eventId', this.eid);
        },

        /**
         * Opens the export qr-codes list modal
         */
        openExportModal() {
            this.$modal.show(ListExportModal, {
                title: 'QR codes',
                fpType: 'attendance-qr',
                exporter: '', // the default exporter will be used
                event: this.params.event
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        /**
         * @returns {string} the HREF for the qr-codes creation page
         */
        getNewQrCodeHref() {
            const route = get(this.params, 'module.controllers.create.route');
            return route.replace(':eventId', this.eid);
        },

        /**
         * @returns {string} the HREF for the qr-codes list import
         */
        getExcelImportHref() {
            return this.$utils.url.getImportExportHref('session-check-in/import-qrs', this.eid, 'event');
        },

        /**
         * Sets the sortable field and reload the collection
         *
         * @param {object} cellConfig the configuration for the cell
         */
        setSortable(cellConfig) {
            if (!cellConfig.sortable) {
                return;
            }

            this.sortField = cellConfig.sortable;
            this.loadData();
        },

        /**
         * Renders the cell with the given field and item
         *
         * @param {object} cellConfig the configuration for the cell
         * @param {object} item the FP typed item
         *
         * @returns {string} a human readable version of the given field
         */
        render(cellConfig, item) {
            const value = item[cellConfig.field];
            return value || value === 0 ? value : '×';
        },

        /**
         * Renders the cell tooltip if available
         *
         * @param {object} cellConfig the configuration for the cell
         * @param {object} item the FP typed item
         *
         * @returns {string} a tooltip text
         */
        renderTooltip(cellConfig, item) {
            if (isFunction(cellConfig.tip)) {
                return cellConfig.tip(item, this.$i18n);
            }
        },

        /**
         * Determines the CSS classes to print on the given cell
         *
         * @param {object} cellConfig the configuration for the cell
         *
         * @returns {string[]} a list of CSS classes to use for the cell
         */
        rowClasses(cellConfig) {
            return [cellConfig.cssClass || cellConfig.field, 'ellipsis'];
        },

        /**
         * Compiles a link in the context of the given cell
         *
         * @param {string} link the link for the cell
         * @param {object} item the FP typed item
         *
         * @returns {string} a compiled version of the link for this cell
         */
        cellLink(link, item) {
            return this.$services.documents.buildUrl(link, { eventId: this.eid, ...item });
        },

        promptDelete(qrCodes) {
            this.$modal.show('dialog', {
                text: this.$t('self_check_in.messages.prompt_deletes'),
                buttons: [
                    {
                        title: this.$t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general.confirm'),
                        handler: async () => {
                            this.deleteQrCodes(qrCodes);
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        /**
         * Bulk delete given qr-codes
         *
         * @param {arrray} qrCodes the list of selected qr-codes
         */
        async deleteQrCodes(qrCodes) {
            try {
                const ids = qrCodes.map(qrCode => qrCode.fp_ext_id);
                await this.$services.documents.deleteDocs(this.eid, this.params.event.node, 'attendance-qr', ids);

                await this.loadData();
                this.$refs.table.unselectAll();

            } catch (error) {
                console.error('[SelfSessionCheckin] An error occurred', error.message || error);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('general.try_later').toString(),
                    type: 'error',
                    duration: 5000
                });
            }
        },

        /**
         * @returns {string} the HREF for the qr-codes images export
         */
        exportQrImages() {
            const route = 'api/v1/eid/:eventId/nodehandlers/session-check-in/download_qrs';
            const link = document.createElement('a');
            link.href = route.replace(':eventId', this.eid);
            link.click();
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-codes"},[_c('smart-table',{ref:"table",attrs:{"track-by":"_id","hide-pagination":_vm.searchTerm.length > 0,"items-per-page":_vm.limit,"items":_vm.rows,"selectable":true,"total-items":_vm.total || _vm.rows.length},on:{"next":_vm.loadData,"previous":_vm.loadData,"select-page":_vm.loadData},scopedSlots:_vm._u([{key:"filters",fn:function(ref){return [_c('search-bar',{attrs:{"show-no-result":false},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})]}},{key:"actions",fn:function(ref){return [_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.newQrCode()}},[_vm._v(_vm._s(_vm.$t('self_check_in.qr_codes.actions.new_qr')))]),_c('a',{staticClass:"btn",on:{"click":function($event){return _vm.openExportModal()}}},[_vm._v(_vm._s(_vm.$t('self_check_in.qr_codes.actions.export_xls')))]),_c('a',{staticClass:"btn",attrs:{"href":_vm.getExcelImportHref()}},[_vm._v(_vm._s(_vm.$t('self_check_in.qr_codes.actions.import_xls')))]),_c('a',{staticClass:"btn",on:{"click":function($event){return _vm.exportQrImages()}}},[_vm._v(_vm._s(_vm.$t('self_check_in.qr_codes.actions.export_qrs')))])]}},{key:"bulk-actions",fn:function(ref){
var selectedItems = ref.selectedItems;
return [_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.promptDelete(selectedItems)}}},[_vm._v(_vm._s(_vm.$t("self_check_in.qr_codes.list.delete")))])]}},{key:"headers",fn:function(ref){return _vm._l((_vm.cols),function(c){return _c('th',{class:[c.cssClass || c.field],on:{"click":function($event){return _vm.setSortable(c)}}},[_c('span',[_vm._v(_vm._s(_vm.$te(c.label) ? _vm.$t(c.label) : c.label))]),(c.sortable === _vm.sortField)?_c('i',{staticClass:"ic-icon"}):_vm._e()])})}},{key:"row",fn:function(ref){
var item = ref.item;
return _vm._l((_vm.cols),function(c){return _c('td',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.renderTooltip(c, item)),expression:"renderTooltip(c, item)"}],class:_vm.rowClasses(c, item)},[(c.link)?_c('a',{attrs:{"href":_vm.cellLink(c.link, item)}},[_vm._v(_vm._s(_vm.render(c, item)))]):_c('span',[_vm._v(_vm._s(_vm.render(c, item)))])])})}}])})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "QrCodes.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__